// Diagnostics (Query Diagnostics ⚡ + Widget Performance panel) are enabled on:
//   - localhost  (local development)
//   - any -stage slot  (e.g. passv2-portal-linux-eastus-as-production-stage.azurewebsites.net)
// They are disabled on production (pass.cdc.gov, passv2-portal-linux-eastus-as.azurewebsites.net).
// We use a runtime hostname check instead of NODE_ENV because React always builds
// with NODE_ENV=production for both production and staging deployments.
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const diagnosticsEnabled = hostname === 'localhost' || hostname.includes('-stage');

export default diagnosticsEnabled;
